import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { c as y } from "../clsx-OuTLNxxd.js";
import { A as h, a as d } from "../Avatar-BG4Ek2lp.js";
import { B as f } from "../Button-BrO5Axzv.js";
import '../Profile.css';const r = "320px", _ = "600px", z = "1025px", H = "_profile_v6xgk_32", p = "_image_v6xgk_36", u = "_name_v6xgk_44", b = "_description_v6xgk_49", S = "_link_v6xgk_50", W = "_details_v6xgk_84", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: r,
  "mobile-wide": "480px",
  tablet: _,
  "tablet-wide": "800px",
  desktop: z,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  profile: H,
  image: p,
  name: u,
  description: b,
  link: S,
  "layout-column": "_layout-column_v6xgk_77",
  "layout-row": "_layout-row_v6xgk_81",
  details: W,
  "size-s": "_size-s_v6xgk_91",
  "size-m": "_size-m_v6xgk_96",
  "size-l": "_size-l_v6xgk_107"
}, w = ({
  description: x,
  headingLevel: s = "h3",
  image: c,
  layout: a = "column",
  name: n,
  profileLink: i,
  size: g = "m",
  ...o
}) => {
  const m = s;
  return /* @__PURE__ */ l(
    "div",
    {
      "data-cxy-name": "profile",
      ...o,
      className: y(e.profile, e[`size-${g}`], e[`layout-${a}`], o.className),
      children: [
        /* @__PURE__ */ t(h, { className: e.image, children: /* @__PURE__ */ t(d, { alt: `Image of ${n}`, src: c }) }),
        /* @__PURE__ */ l("div", { className: e.details, children: [
          /* @__PURE__ */ t(m, { className: e.name, children: n }),
          x && /* @__PURE__ */ t("p", { className: e.description, dangerouslySetInnerHTML: { __html: x } }),
          i && /* @__PURE__ */ t(f, { asChild: !0, className: e.link, variant: "ghostBrand", children: /* @__PURE__ */ t("a", { href: i.href, children: i.text }) })
        ] })
      ]
    }
  );
};
export {
  w as Profile
};
